// extracted by mini-css-extract-plugin
export var brand = "styles_brand__X-ETn";
export var container = "styles_container__T1EgS";
export var details = "styles_details__bzUjX";
export var disabled = "styles_disabled__meQ2V";
export var name = "styles_name__+Jfcd";
export var ratingContainer = "styles_ratingContainer__dDPkK";